import { render, staticRenderFns } from "./ReadOnlyInfo.vue?vue&type=template&id=47ac419c"
import script from "./ReadOnlyInfo.vue?vue&type=script&lang=js"
export * from "./ReadOnlyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports